<template>
    <div class="wai">
        <div class="wyjj">
            <div class="wyjjitem" v-for="(item,index) in list" :key="index" @click="go(item)">
                <div class="zfx">
                    <img :src="item.src" alt="">
                </div>
                <span>{{item.name}}</span>
            </div>
            <div class="wyjjitem"></div>
            <div class="wyjjitem"></div>
            <div class="wyjjitem"></div>
            <div class="wyjjitem"></div>

        </div>
    </div>
    
</template>
<script>
export default {
    data() {
        return {
            list:[
                {
                    name:'基本信息',
                    src:require('../../../assets/wyjj/jbxx.png'),
					path:'/wyfw/wyjj/jbxxxq'
                },
				// {
				//     name:'服务人员',
				//     src:require('../../../assets/wyjj/fwry.png'),
				// 	path:'/wyfw/wyjj/fwry'
				// },
                // {
                //     name:'服务合同',
                //     src:require('../../../assets/wyjj/fwht.png'),
				// 	path:'/wyfw/wyjj/fwht'
                // },
                // {
                //     name:'服务事项',
                //     src:require('../../../assets/wyjj/fwsx.png'),
				// 	path:'/wyfw/wyjj/fwsx'
                // },
                // {
                //     name:'收费信息',
                //     src:require('../../../assets/wyjj/sfbz.png'),
				// 	 path: "/wyfw/wyjj/sfxx"
                // },
                // {
                //     name:'收入公示',
                //     src:require('../../../assets/wyjj/srgs.png'),
				// 	 path: "/wyfw/wyjj/srgs"
                // },
                // {
                //     name:'业主委员会',
                //     src:require('../../../assets/yzjc/yzwyh.png'),
                //     path: "/yzjc/yzwyh"
                // },
                // {
                //     name:'党支部',
                //     src:require('../../../assets/yzjc/2.png'),
                //     path: "/hsyw/dzbdetail"
                // },
                // {
                //     name:'楼栋长',
                //     src:require('../../../assets/yzjc/1.png'),
                //     path: "/common/list/ldz"
                // },
                // {
                //     name:'法律法规',
                //     src:require('../../../assets/yzjc/fl.png'),
                //     path: "/flfg"
                // },
                // {
                //     name:'业主决策',
                //     src:require('../../../assets/yzjc/yzjc.png'),
                //     path: "/yzjc"
                // },
                // {
                //     name:'小区党支部',
                //     src:require('../../../assets/wyjj/fwry.png'),
                //     path: "/hsyw/dzbdetail"
                // },{
                //     name:'支部生活',
                //     src:require('../../../assets/yzjc/2.png'),
                //     path: "/common/list/zbsh"
                // },
            ]
        }
    },
    mounted() {
        
    },
    methods: {
        go(item){
            this.$router.push({ path: item.path, query: {} });
            
        }
    },
}
</script>
<style lang="less" scoped>
.wai{
    display: flex;
    justify-content: center;
}
    .wyjj{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        .wyjjitem{
            height: 120px;
            width: 100px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            .zfx{
                height: 70px;
                width: 70px;
                background-color: #00b5ff;
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    height: 50px;
                    width: 50px;
                }
            }
            span{
                margin-top: 5px;
            }
        }
    }
</style>